<template>
  <div class="sellCenter container">
    <!-- 过滤条件start -->
    <div ref="headerBtn" class="headerBtn">
      <!-- 顶部按钮start -->
      <div>
        <el-form ref="form" size='mini' :inline="true" label-width="80px">
          <el-form-item
            ><el-button size="mini" @click="resetPage" type="info"
              >刷新</el-button
            ></el-form-item
          >
          

          <el-form-item label="客户名称：">
            <el-select
              size="mini"
              filterable
              class="itemBox"
              v-model="selectedCustomer"
              placeholder="请选择查询客户"
            >
              <el-option label="不限" value=""></el-option>
              <el-option
                v-for="(item, index) in custlist"
                :key="index"
                :label="item.nickName"
                :value="item.userId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品名称：">
            <el-select
              size="mini"
              filterable
              class="itemBox"
              v-model="selectedGoods"
              placeholder="请选择查询商品"
            >
              <el-option label="不限" value=""></el-option>
              <el-option
                v-for="(item, index) in goodsList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="优惠方式：">
            <el-select
              size="mini"
              filterable
              class="itemBox"
              v-model="discType"
              placeholder="选择优惠方式"
            >
              <el-option label="不限" value=""></el-option>
              <el-option label="折扣" value="1"></el-option>
              <el-option label="按销量分段优惠" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" @click="searchData" type="primary"
              >查询</el-button
            >
          </el-form-item>
         
        </el-form>
        <el-form size='mini' :inline="true"  label-width="80px">
           <el-form-item
            ><el-button @click="addDiscount" size="mini" type="info"
              >添加优惠</el-button
            ></el-form-item
          >
          <el-form-item>
            <el-button size="mini" @click="deleteItemConfirm" type="primary"
              >批量删除</el-button
            >
          </el-form-item>
        </el-form>
      </div>

      <!-- 顶部按钮end -->
    </div>
    <!-- 过滤条件end -->
    <div>
      <el-table
        :data="list"
        border
        highlight-current-row
        v-loading="loading"
        size="mini"
        ref="tabs"
        :height="tabHeight"
        @selection-change="handleSelectionChange"
        :style="{ 'background-color': 'transparent' }"
        :header-cell-style="{ 'background-color': '#f8f8f8' }"
      >
        <el-table-column  type="expand">
          <el-form
            v-if="scope.row.discList && scope.row.discList"
            slot-scope="scope"
          >
            <el-form-item
              v-for="(item, index) in scope.row.discList"
              :key="index"
            >
              <div class="zkItemBox">
                <span class="zkItemBoxLabel">区间{{ index + 1 }}：</span>
                <div class="numberInput">
                  <el-input
                    :readonly="true"
                    size="mini"
                    v-model="item.min"
                    placeholder="最低销量"
                  >
                    <template slot="append">件</template>
                  </el-input>
                </div>
                <span class="fg">-</span>
                <div class="numberInput">
                  <el-input
                    :readonly="true"
                    size="mini"
                    v-model="item.max"
                    placeholder="最高销量"
                  >
                    <template slot="append">件</template>
                  </el-input>
                </div>
                <span class="fg"></span>
                <div class="numberInput">
                  <el-input
                    :readonly="true"
                    size="mini"
                    v-model="item.price"
                    placeholder="对应单价"
                  >
                    <template slot="append">元/件</template>
                  </el-input>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </el-table-column>
        <el-table-column
          align="center"
          type="selection"
          width="50"
        ></el-table-column>
        <el-table-column align="center" label="序号" type="index" width="50">
        </el-table-column>

        <el-table-column
          width="150"
          show-overflow-tooltip
          align="center"
          label="操作"
        >
          <div slot-scope="scope">
            <!-- <el-button class="_mini" type="info" size="mini">设置</el-button> -->
            <!-- <el-button class="_mini" type="info" size="mini"
              >查看库存</el-button
            > -->

            <el-button
              class="_mini"
              @click="() => deleteDiscount(scope.row)"
              type="danger"
              size="mini"
              >删除</el-button
            >

            <!--
            <el-button class="_mini" type="info" size="mini"
              >设置秒杀</el-button
            > -->
          </div>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="nickName"
          label="客户名称"
          width="150"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="goodsName"
          label="优惠商品名称"
          width="150"
        >
          <div slot-scope="scope">
            <div @click="() => checkGoods(scope.row)" class="hover">
              {{ scope.row.goodsName }}
            </div>
          </div>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="discType"
          label="优惠方式"
          width="150"
        >
          <div slot-scope="scope">
            <div class="blue" v-if="scope.row.discType == 1">折扣</div>
            <div class="green" v-if="scope.row.discType == 2">
              按销量分段优惠
            </div>
          </div>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="name"
          label="优惠内容"
          width="150"
        >
          <div slot-scope="scope">
            <div class="blue" v-if="scope.row.discType == 1">
              {{ scope.row.discRate }}折
            </div>
            <div class="green" v-if="scope.row.discType == 2">
              <el-button
                @click="
                  () => {
                    showDetail(scope.row);
                  }
                "
                size="mini"
                class="_mini"
                type="primary"
                >查看详情</el-button
              >
            </div>
          </div>
        </el-table-column>
      </el-table>
      <!-- 分页start -->
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
          :current-page="pageIndex"
          @current-change="handleCurrentChange"
          :page-size="15"
        >
        </el-pagination>
      </div>
      <!-- 分页end -->
    </div>
  </div>
</template>

<script>
import {
  getImageUrl,
  addStockGoodsUrl,
  getMineWhiteBarListUrl,
  roleSetting,
  delEmpUrl,
  discList,
  custlist,
  queryMyGoodsList,
  batchDelCustDisc,
} from "@/api/api";
import { mapMutations, mapState } from "vuex";
export default {
  name: "whitebar",
  data() {
    return {
      tabHeight: "300px",
      formInline: {
        user: "",
        region: "",
      },
      list: null,
      loading: false,
      total: 0,
      pageIndex: 1,
      whiteBarListShow: false,
      whiteBarList: null,
      whiteBarCount: 0,
      selectedList: null,
      currentRow: null,
      custlist: null,
      selectedCustomer: "",
      selectedGoods: "",
      goodsList: null,
      discType: "",
    };
  },
  mounted() {
    this.getImageUrl = getImageUrl;
    this.setTableHeight();
    window.addEventListener("resize", this.setTableHeight);
    this.initData();
    this.initSearchData();
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    ...mapMutations(["savecurrentEditRow"]),
    searchData() {
      this.pageIndex = 0;
      this.initData(true);
    },
    initSearchData() {
      this.initCustomerSearchData();
      this.initGoodsSearchData();
    },
    initCustomerSearchData() {
      let data = {
        access_token: this.userInfo.access_token,
        store_id: this.userInfo.storeId,
        pageIndex: 0,
        pageSize: 999,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: custlist })
        .then((res) => {
          if (res.data.resultCode == 1) {
            this.custlist = res.data.data || null;
            console.log("this.custlist", this.custlist);
          } else {
            this.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    initGoodsSearchData() {
      let data = {
        access_token: this.userInfo.access_token,
        storeId: this.userInfo.storeId,
        pageIndex: 0,
        pageSize: 999,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: queryMyGoodsList })
        .then((res) => {
          if (res.data.resultCode == 1) {
            this.goodsList = res.data.data || null;
            console.log("this.custlist", this.custlist);
          } else {
            this.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    checkGoods(item) {
      this.$router.push({
        name: "goodsDetail",
        query: {
          goodsId: item.goodsId,
          type: -1,
        },
      });
    },
    showDetail(row) {
      this.$refs.tabs.toggleRowExpansion(row, true);
    },
    deleteItemConfirm(){
        if ((!this.selectedList)||(!this.selectedList.length)) {
        this.$alert("请勾选删除行", "提示");
        return;
      }
    this.$confirm(`确认删除选中的${this.selectedList.length}条优惠项?`, "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        // type: "warning"
      })
        .then(() => {
          this.deleteItems();
        })
        .catch(() => {});
    },
    deleteItems() {

      let ids = this.selectedList.map((item) => item.id).join(",");
      let data = {
        access_token: this.userInfo.access_token,
        ids,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: batchDelCustDisc })
        .then((res) => {
          if (res.data.resultCode == 1) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.initData();
          } else {
            this.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    handleCurrentChange(e) {
      console.log(e);
      this.pageIndex = e;
      setTimeout(() => {
        this.initData();
      });
    },
    deleteDiscount(row) {
      this.$confirm("确认删除该条优惠?", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        // type: "warning"
      })
        .then(() => {
          this.ensureDeleteRow(row);
        })
        .catch(() => {});
    },
    ensureDeleteRow(row) {
      this.loading = true;
      let that = this;
      console.log("this.userInfo", this.userInfo);
      let data = {
        access_token: this.userInfo.access_token,
        ids:row.id
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: batchDelCustDisc })
        .then(function (res) {
          that.loading = false;
          if (res.data.resultCode == 1) {
            that.$message({
              message: "操作成功",
              type: "success",
            });
            that.initData();
          } else {
            that.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(function (error) {
          that.loading = false;
          that.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    resetPage() {
      location.reload();
    },
    handleSelectionChange(e) {
      this.selectedList = e;
    },
    initData() {
      this.loading = true;
      let that = this;
      console.log("this.userInfo", this.userInfo);
      let data = {
        access_token: this.userInfo.access_token,
        storeId: this.userInfo.storeId,
        pageIndex: this.pageIndex - 1,
        pageSize: 15,
        discType: this.discType,
        userId: this.selectedCustomer,
        goodsId: this.selectedGoods,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: discList })
        .then(function (res) {
          that.loading = false;
          if (res.data.resultCode == 1) {
            console.log("res.data", res.data.data);
            that.list = res.data.data;
            that.total = res.data.count || 0;
          } else {
            that.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          that.loading = false;
          that.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    addDiscount() {
      this.$router.push({ name: "addDiscount" });
    },
    setTableHeight() {
      //
      setTimeout(() => {
        let headerBtn = document.getElementsByClassName("headerBtn")[0]
          .offsetHeight;
        let paginationBtn = document.getElementsByClassName("pagination")[0]
          .offsetHeight;
        let tabHeight = window.innerHeight - headerBtn - paginationBtn - 110;
        if (tabHeight < 300) {
          tabHeight = 300;
        }
        this.tabHeight = tabHeight + "px";
      }, 100);
    },
  },
};
</script>

<style scoped lang='less'>
.headerBtn {
  width: 90%;
  margin-top: 10px;
}
.container {
  margin: 10px;
}
.pagination {
  margin-top: 10px;
  width: 200px;
  display: flex;
  justify-content: flex-start;
}

.green {
  color: green;
}
.blue {
  color: blue;
}

.numberInput {
  width: 150px;
  position: relative;
  top: 5px;
}
.zkItemBox {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.fg {
  margin: 0 10px;
}
.zkItemBoxLabel {
  font-size: 12px;
  color: #666;
  margin-right: 10px;
}

.sellCenter {
  overflow: hidden;
}
.warning {
  color: #f40;
  margin-left: 10px;
}

// .formInnerBox {
//   display: flex;
//   flex-direction: column;
//   flex-wrap: wrap;
//   align-items: flex-start;
//   max-width: 550px;
// }
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.formInfo {
  display: inline-block;
  height: 30px;
  margin-bottom: 20px;
}
.hover {
  cursor: pointer;
  
}
.hover:hover{
  color:#009e96
}
.itemBox {
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/DiscountManage.vue